import styled from '@emotion/styled';
import { Typography } from 'antd';

export const SContainer = styled.div`
  height: 66px;
  position: relative;
  padding: 12px 16px;
`;

export const SMenuTrigger = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 32px;
  height: 32px;
`;

export const SLabel = styled(Typography.Text)`
  font-size: 12px;
`;

export const SDangerItem = styled.div`
  color: #ff4d4f;
`;
